import { makeStyles } from "@material-ui/core";


export interface StylesProps {
    maxHeight?: number;
}

export default makeStyles((theme) => ({
    buttonIcon: {
        color: theme.palette.grey[700],
        cursor: "pointer",
        margin: "0px 16px 4px 16px",
    },
    close: {
        position: "absolute",
        top: 12,
        right: 12,
        color: theme.palette.grey[700],
    },
    container: {
        display: "flex",
        flexDirection: "column",
    },
    header: {
        // fontFamily: "Oswald", // TODO: get the correct font
        fontWeight: 700,
        fontSize: 20,
        color: theme.palette.grey[900],
        textTransform: "uppercase",
        marginBottom: 12,
    },
    iconArea: {
        position: "absolute",
        right: 4,
        minWidth: 0,
    },
    list: {
        maxHeight: ({ maxHeight }: StylesProps) => maxHeight ? maxHeight - 120 : undefined,
        marginBottom: ({ maxHeight }: StylesProps) => maxHeight ? 56 : 0,
        overflowY: "scroll",
        padding: 0,
        scrollbarWidth: "none", /* Firefox */
        "&::-webkit-scrollbar": {
            display: "none", /* Safari and Chrome */
        },
    },
    listFooter: {
        position: "absolute",
        bottom: 0,
        left: 0,
        backgroundColor: theme.palette.background.paper,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 56,
        boxShadow: "0px -8px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "0px 0px 12px 12px",
    },
    playIcon: {
        fill: theme.palette.grey[700],
    },
    popover: {
        maxHeight: ({ maxHeight }: StylesProps) => maxHeight,
        padding: 20,
        color: theme.palette.grey[700],
        boxShadow: "0 0 12px rgba(0, 0, 0, 0.1)",
        borderRadius: 12,
        width: 380,
        overflow: "hidden",
    },
    soundAnimation: {
        width: 24,
        marginLeft: 8,
    },
}));
